import { render, staticRenderFns } from "./USDT.vue?vue&type=template&id=15715c47&"
import script from "./USDT.vue?vue&type=script&lang=js&"
export * from "./USDT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports